<template>
  <div class="fill">
    <!-- mapa e pois desktop -->
    <v-row class="hidden-sm-and-down">
      <v-col cols="8" class="mb-5">
        <GmapMap :center="centredBloco" :zoom="4" class="fill">
          <GmapCustomMarker :key="index" v-for="(bloco, index) in blocos" :marker="bloco.position">
            <v-tooltip top>
              <template #activator="{ on }">
                <v-icon
                  v-on="on"
                  @click="blocoClick(index)"
                  large
                  :color="selectedBloco == index ? 'red' : 'grey'"
                  class="mr-3"
                >mdi-map-marker</v-icon>
              </template>
              <span>{{bloco.nome}}</span>
            </v-tooltip>
          </GmapCustomMarker>
        </GmapMap>
      </v-col>

      <v-col cols="4" class="mb-5">
        <v-list class="v-list-scroll" width="100%">
          <div style="width:100%" v-for="(bloco, index) in blocos" :key="index + 1">
            <!-- Escondido so em md -->
            <v-card
              @click="blocoClick(index)"
              color="#1e1e1e"
              width="100%"
              class="d-md-none d-lg-flex mb-5 pa-3 mr-5"
            >
              <v-col cols="2" class="d-flex align-center justify-center">
                <v-avatar size="40" :color=" selectedBloco == index ? 'red' : 'grey'">
                  <span class="white--text">{{(index + 1)}}</span>
                </v-avatar>
              </v-col>
              <v-col cols="7">
                <v-row>
                  <div class="white--text ml-2 text-truncate">{{bloco.nome}}</div>
                </v-row>

                <v-row>
                  <small class="white--text ml-2 text-truncate">{{bloco.morada}}</small>
                </v-row>
              </v-col>

              <v-col cols="3" class="d-flex align-center">
                <v-btn
                  block
                  class="white--text d-flex text-right"
                  @click.stop="goBloco(bloco.bloco_id)"
                  :color="selectedBloco == index ? 'red' : 'grey'"
                >abrir</v-btn>
              </v-col>
            </v-card>

            <!-- visivel so em md -->
            <v-card
              @click="blocoClick(index)"
              color="#1e1e1e"
              width="100%"
              class="d-none d-md-flex d-lg-none mb-5 pa-3 mr-5"
            >
              <v-col cols="3" class="d-flex align-center justify-center">
                <v-avatar size="40" :color=" selectedBloco == index ? 'red' : 'grey'">
                  <span class="white--text">{{(index + 1)}}</span>
                </v-avatar>
              </v-col>
              <v-col cols="9">
                <v-row>
                  <div class="white--text ml-2 text-truncate">{{bloco.nome}}</div>
                </v-row>
                <v-row>
                  <small class="white--text ml-2 text-truncate">{{bloco.morada}}</small>
                </v-row>
                <v-row>
                  <v-btn
                    class="ml-2 mt-2 white--text d-flex text-right"
                    @click.stop="goBloco(bloco.bloco_id)"
                    :color="selectedBloco == index ? 'red' : 'grey'"
                  >abrir</v-btn>
                </v-row>
              </v-col>
            </v-card>
          </div>
        </v-list>
      </v-col>
    </v-row>

    <!-- mapa e pois mobile -->
    <v-row class="hidden-md-and-up">
      <v-col>
        <GmapMap :center="centredBloco" :zoom="4" class="mapHeight">
          <GmapCustomMarker :key="index" v-for="(bloco, index) in blocos" :marker="bloco.position">
            <v-tooltip top>
              <template #activator="{ on }">
                <v-icon
                  v-on="on"
                  @click="blocoClick(index)"
                  large
                  :color="selectedBloco == index ? 'red' : 'grey'"
                  class="mr-3"
                >mdi-map-marker</v-icon>
              </template>
              <span>{{bloco.nome}}</span>
            </v-tooltip>
          </GmapCustomMarker>
        </GmapMap>
      </v-col>
    </v-row>

    <v-row class="hidden-md-and-up">
      <v-col>
        <v-list class="v-list-scroll-sm" width="100%">
          <div class="fillw" v-for="(bloco, index) in blocos" :key="index + 1">
            <v-card
              v-h
              @click="blocoClick(index)"
              color="#1e1e1e"
              width="100%"
              class="mb-5 pa-3 mr-5"
            >
              <div class="d-flex align-center" :id="'bloco-' + index">
                <v-chip
                  :color=" selectedBloco == index ? 'red' : 'grey'"
                  class="white--text"
                >{{(index + 1)}}</v-chip>
                <div class="d-flex flex-column ml1 fillw">
                  <div class="white--text ml-2 text-truncate">{{bloco.nome}}</div>
                  <small class="white--text ml-2 text-truncate">{{bloco.morada}}</small>
                </div>

                <v-btn
                  class="white--text d-flex text-right"
                  @click.stop="goBloco(bloco.bloco_id)"
                  :color="selectedBloco == index ? 'red' : 'grey'"
                >abrir</v-btn>
              </div>
            </v-card>
          </div>
        </v-list>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import GmapCustomMarker from "vue2-gmap-custom-marker";
export default {
  name: "ComponentMap",
  props: ["selectedBloco", "centredBloco", "idRoteiro", "blocos"],
  components: {
    GmapCustomMarker
  },
  methods: {
    blocoClick(index) {
      this.selectedBloco = index;
      this.centredBloco = this.roteiro.blocos[index].position;

      var elmnt = document.getElementById("bloco-" + index);
      elmnt.scrollIntoView();
    },
    goBloco(idBloco) {
      var pathBloco =
        "/" +
        this.$store.getters.language +
        "/roteiro/" +
        this.idRoteiro +
        "/bloco/" +
        idBloco;
      this.$router.replace({ path: pathBloco });
      this.$router.go(0);
    }
  },
  async mounted() {}
};
</script>
